export default "__VITE_ASSET__3w80Ey3O__"